import * as React from 'react';

import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { ShowShareTable, IShareTableData } from 'src/component/shared';
import { MarketCategoryThirtyDaysVolumeEvolutionModal } from './modal/MarketCategoryThirtyDaysVolumeEvolutionModal';
// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysVolumeEvolutionProps {
    categoriesVolumeArrayProp: string[],
    data: any[],
    loading: boolean
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCategoryThirtyDaysVolumeEvolutionState {
    isUpdate: boolean,
    customFilter: {
        isChart: boolean
    },
}

const dataFilled = (data: any) => {
    return data && data.marketCategoryThirtyDaysEvolution && !!data.marketCategoryThirtyDaysEvolution.length
}

export class MarketCategoryThirtyDaysVolumeEvolution extends React.Component<IMarketCategoryThirtyDaysVolumeEvolutionProps, IMarketCategoryThirtyDaysVolumeEvolutionState> {
    constructor(props: IMarketCategoryThirtyDaysVolumeEvolutionProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            isUpdate: false,
        }

    }

    public render() {
        return this.dataToRend(this.props.data, this.props.loading);
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {

        let volumeDataArray : any[] = [];
        if(!loading && data && data.marketCategoryThirtyDaysEvolution 
            && data.marketCategoryThirtyDaysEvolution.length ) {
            data.marketCategoryThirtyDaysEvolution.forEach((item: any) => {
                const volumeItem : any = {
                    name: item.category,
                    value: item.volume_evolution
                }
                if(!this.props.categoriesVolumeArrayProp.includes(volumeItem.name)){
                    volumeItem.order = 100;
                } else {
                    volumeItem.order = this.props.categoriesVolumeArrayProp.indexOf(volumeItem.name);
                }
                volumeDataArray.push(volumeItem);
            });

            volumeDataArray = volumeDataArray.sort((obj1:any,obj2:any)=> {
                return obj1.order - obj2.order;
            });
        }

        return  (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Crescimento Volume - ULT. 30 DIAS X ANO ANT
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (
                            <div>
                                <div style={{height: 334, overflowX: 'auto', overflowY: 'hidden'}}>
                                    <ShowShareTable data={volumeDataArray.filter(
                                        (element:IShareTableData, index: number) => index<=10 )} styleValue={1} />
                                </div>
                                <MarketCategoryThirtyDaysVolumeEvolutionModal 
                                    categoriesVolumeArrayProp={this.props.categoriesVolumeArrayProp} 
                                    data={volumeDataArray}
                                    loading={loading}
                                />
                            </div>
                        )
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/categories/thirty-days/volume-evolution/MarketCategoryThirtyDaysVolumeEvolution.tsx